import styled from "styled-components";

export const OrdersSectionSection = styled.div.attrs({ className: "mt-8" })``;
